export default function MenuSkeleton() {
  return (
    <div className="min-h-screen bg-gray-50 animate-pulse">
      {/* Header Skeleton */}
      <div className="bg-white border-b">
        <div className="h-40 md:h-48 bg-gray-200"></div>
        <div className="max-w-6xl mx-auto px-4 py-4">
          <div className="flex items-start gap-4">
            <div className="h-16 w-16 md:h-20 md:w-20 rounded-lg bg-gray-300"></div>
            <div className="flex-1 space-y-2">
              <div className="h-6 bg-gray-300 rounded w-48"></div>
              <div className="h-4 bg-gray-200 rounded w-32"></div>
            </div>
          </div>
        </div>
      </div>

      {/* Category Nav Skeleton */}
      <div className="sticky top-[180px] bg-white border-b">
        <div className="max-w-6xl mx-auto px-4 py-3 flex gap-2">
          <div className="h-10 w-32 bg-gray-200 rounded-full"></div>
          <div className="h-10 w-32 bg-gray-200 rounded-full"></div>
          <div className="h-10 w-32 bg-gray-200 rounded-full"></div>
        </div>
      </div>

      {/* Menu Items Skeleton */}
      <div className="max-w-6xl mx-auto px-4 py-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {[1, 2, 3, 4, 5, 6].map((i) => (
            <div key={i} className="bg-white rounded-lg p-3 shadow-sm border">
              <div className="flex gap-3">
                <div className="h-24 w-24 bg-gray-200 rounded-lg"></div>
                <div className="flex-1 space-y-2">
                  <div className="h-5 bg-gray-300 rounded w-3/4"></div>
                  <div className="h-4 bg-gray-200 rounded w-full"></div>
                  <div className="h-4 bg-gray-200 rounded w-5/6"></div>
                  <div className="h-6 bg-gray-300 rounded w-20"></div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
